import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ZModal } from '@zanichelli/albe-web-components/react';

import Hidden from '../layouts/components/hidden';

export const HiddenCloseModalButton = styled.div``;

export const Container = styled.div`
    top: 0;
    left: 0;
    right: 0;

    position: fixed;
    background-color: rgba(51, 51, 51, 0.7);
    width: 100%;
    height: 100%;

    z-index: 20;

    animation-name: fadeInOverlay;
    animation-duration: 0.3s;

    @keyframes fadeInOverlay {
        from {
            background-color: rgba(0, 0, 0, 0);
        }
        to {
            background-color: rgba(51, 51, 51, 0.7);
        }
    }
`;

export const ModalWrapper = styled.div`
    animation-name: fadeIn;
    animation-duration: 0.3s;

    @keyframes fadeIn {
        from {
            transform: scale(0.5);
        }
        to {
            transform: scale(1);
        }
    }
`;

export const Dialog = styled.div`
    max-width: 100%;
    box-sizing: border-box;
    padding: calc(var(--space-unit) * 2);
    border-radius: 0px;

    @media (min-width: 768px) {
        min-width: calc(var(--space-unit) * 60);
        padding: calc(var(--space-unit) * 4);
        border-radius: 4px;
    }

    background-color: var(--color-white);
    margin-left: auto;
    margin-right: auto;
    overflow-y: auto;
`;

const Modal = ({ title, children, showCloseButton = true, subtitle, onClose, closeOnClickOutside = true }) => {
    const modal = useRef();

    return (
        <Hidden $print={true}>
            <Container
                onClick={(e) => {
                    e.stopPropagation();

                    if (closeOnClickOutside && !modal.current.contains(e.target)) {
                        onClose();
                    }
                }}
            >
                <ModalWrapper>
                    <ZModal modaltitle={title} modalsubtitle={subtitle} onModalClose={onClose}>
                        {!showCloseButton && <HiddenCloseModalButton slot="modalCloseButton" />}
                        <Dialog ref={modal} slot="modalContent">
                            {children}
                        </Dialog>
                    </ZModal>
                </ModalWrapper>
            </Container>
        </Hidden>
    );
};

Modal.propTypes = {
    showCloseButton: PropTypes.node,
    children: PropTypes.node,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    onClose: PropTypes.func,
    closeOnClickOutside: PropTypes.bool,
};

export default Modal;
